const LEADING_ZERO_REGEX = /^(0{1,})(\d{0,})$/gi;

function hasLeadingZero(value: string): boolean {
    return LEADING_ZERO_REGEX.test(value);
}

function trimLeadingZero(value: string): string {
    if (hasLeadingZero(value)) {
        return value.replace(LEADING_ZERO_REGEX, '$2');
    }
    return value;
}

const LEADING_PLUS_REGEX = /^(\+)(\d{0,})$/;

function hasLeadingPlus(value: string): boolean {
    return LEADING_PLUS_REGEX.test(value);
}

export default function formatPhoneNumber(phoneNumber: string): string {
    const countryCode = `${process.env.REACT_APP_COUNTRY_CODE}`;
    const formatedPhoneNumber = phoneNumber.trim();

    if (hasLeadingPlus(formatedPhoneNumber)) {
        return formatedPhoneNumber;
    }

    if (formatedPhoneNumber.length === 9 || formatedPhoneNumber.length === 10) {
        return `${countryCode}${formatedPhoneNumber}`;
    }

    if (formatedPhoneNumber.length === 11) {
        if (formatedPhoneNumber.startsWith('0')) {
            return `${countryCode}${formatedPhoneNumber.slice(1)}`;
        }

        return `+${formatedPhoneNumber}`;
    }

    if (formatedPhoneNumber.length > 11) {
        if (formatedPhoneNumber.startsWith('0')) {
            return `+${trimLeadingZero(formatedPhoneNumber)}`;
        }

        return `+${formatedPhoneNumber}`;
    }

    return formatedPhoneNumber;
}
